import { render, staticRenderFns } from "./suggestedProducts.vue?vue&type=template&id=ba239732&lang=pug"
import script from "./suggestedProducts.vue?vue&type=script&lang=js"
export * from "./suggestedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports